import qs from 'qs'
import {
  checkHttpStatus, getApiBaseUrl,
  getApiBaseUrlWithOrg,
  getApiHeadersFromToken
} from 'utils/api'

export const fetchCourseLevelsQuests = async function (apiData, courseId) {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/courses/${courseId}/levels_quests`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )

    return await response.json()
  } catch (e) {
    return null
  }
}

export const fetchLevelsQuestsProgress = async function (
  apiData,
  isMentor,
  userId,
  courseSectionId
) {
  const params = qs.stringify({
    q: {
      include_quests_progress: true,
      include_target_dates: true
    }
  })

  const url = `
    ${getApiBaseUrlWithOrg(apiData.orgId)}/${
    isMentor ? 'users/' + userId + '/' : 'user/'
  }course_sections/${courseSectionId}/levels_progress?${params}
  `

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )

    return await response.json()
  } catch (e) {
    return null
  }
}

export const fetchLevelDetails = async function (
  apiData,
  masterCourseId,
  courseId,
  levelId
) {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/master_courses/${masterCourseId}/courses/${courseId}/levels/${levelId}`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )

    return await response.json()
  } catch (e) {}
}

export const fetchQuestHoverDetails = async function (
  apiData,
  compiledQuestId
) {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/compiled_quests/${compiledQuestId}/hover`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )

    return await response.json()
  } catch (e) {}
}

export const fetchCourseSectionEstimatedCompletionStats = async function (
  apiData,
  isMentor,
  userId,
  courseSectionId
) {
  const params = qs.stringify({
    q: {
      include_completed_activities_this_week: true
    }
  })

  const url = `${getApiBaseUrlWithOrg(apiData.orgId)}/${
    isMentor ? 'users/' + userId : 'user'
  }/course_sections/${courseSectionId}/estimated_completion_stats?${params}`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )

    return await response.json()
  } catch (e) {
    return null
  }
}

export const fetchCourseSectionUnreadNotificationCounts = async function (
  apiData,
  courseSectionId
) {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/user/course_sections/${courseSectionId}/unread_notifications_count`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )

    const obj = await response.json()
    return obj?.unread_notifications_count
  } catch (e) {
    return null
  }
}

export const fetchCourseSectionAppliedSkillCounts = async function (
  apiData,
  courseSectionId
) {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/course_sections/${
    courseSectionId
  }/activity_focus_skills/counts_by_skill_group`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )

    return await response.json()
  } catch (e) {
    return null
  }
}

export const fetchCourseSectionActivityAppliedSkills = async function (
  apiData,
  courseSectionId
) {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/course_sections/${
    courseSectionId
  }/activity_focus_skills`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )

    return await response.json()
  } catch (e) {
    return null
  }
}

export const fetchCourseQuestsActivities = async function (
  apiData,
  courseId
) {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/courses/${courseId}/quests_activities`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )

    return await response.json()
  } catch (e) {
    return null
  }
}

export const fetchCourseSectionAppliedGuidanceCounts = async function (
  apiData,
  courseSectionId
) {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/course_sections/${
    courseSectionId
  }/mentor_quest_guidances/counts_by_resource_type`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )

    return await response.json()
  } catch (e) {
    return null
  }
}

export const fetchCourseSectionMentorGuidances = async function (
  apiData,
  courseSectionId
) {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/course_sections/${
    courseSectionId
  }/mentor_quest_guidances`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )

    return await response.json()
  } catch (e) {
    return null
  }
}

export const addJourneyResource = async (
  apiData,
  courseSectionId,
  resource,
  newFileUpload,
  applyToAllSections
) => {
  try {
    const response = checkHttpStatus(
      await fetch(
        `${getApiBaseUrl()}/api/organizations/${
          apiData.orgId
        }/mentor/course_sections/${courseSectionId}/mentor_course_resources`,
        {
          method: 'POST',
          headers: getApiHeadersFromToken(apiData.token),
          body: JSON.stringify({
            mentor_course_resource: {
              ...resource,
            },
            new_file_upload: newFileUpload,
            apply_to_all_sections: applyToAllSections
          })
        }
      )
    )

    return await response.json()
  } catch (error) {
    return null
  }
}

export const patchJourneyResourceFileShell = async (
  apiData,
  courseSectionId,
  resourceId,
  file
) => {
  try {
    const response = checkHttpStatus(
      await fetch(
        `${getApiBaseUrl()}/api/organizations/${
          apiData.orgId
        }/mentor/course_sections/${courseSectionId}/mentor_course_resources/${resourceId}/file`,
        {
          method: 'PATCH',
          headers: getApiHeadersFromToken(apiData.token),
          body: JSON.stringify({
            mentor_course_resource: file
          })
        }
      )
    )

    return await response.json()
  } catch (error) {
    return null
  }
}

export const fetchJourneyMentorResources = async (
  apiData,
  courseSectionId,
) => {
  try {
    const response = checkHttpStatus(
      await fetch(
        `${getApiBaseUrl()}/api/organizations/${
          apiData.orgId
        }/course_sections/${courseSectionId}/mentor_course_resources`,
        {
          method: 'GET',
          headers: getApiHeadersFromToken(apiData.token)
        }
      )
    )
    return await response.json()
  } catch (error) {
    return null
  }
}

export const patchJourneyMentorResource = async (
  apiData,
  courseSectionId,
  resourceId,
  resource
) => {
  try {
    const response = checkHttpStatus(
      await fetch(
        `${getApiBaseUrl()}/api/organizations/${
          apiData.orgId
        }/mentor/course_sections/${courseSectionId}/mentor_course_resources/${resourceId}`,
        {
          method: 'PATCH',
          headers: getApiHeadersFromToken(apiData.token),
          body: JSON.stringify({
            mentor_course_resource: resource
          })
        }
      )
    )
    return await response.json()
  } catch (error) {
    return null
  }
}

export const deleteJourneyMentorResource = async (
  apiData,
  courseSectionId,
  resourceId,
  applyToAllSections
) => {
  try {
    const response = checkHttpStatus(
      await fetch(
        `${getApiBaseUrl()}/api/organizations/${
          apiData.orgId
        }/mentor/course_sections/${courseSectionId}/mentor_course_resources/${resourceId}`,
        {
          method: 'DELETE',
          headers: getApiHeadersFromToken(apiData.token),
          body: JSON.stringify({
            apply_to_all_sections: applyToAllSections
          })
        }
      )
    )
    return await response.json()
  } catch (error) {
    return null
  }
}

export const fetchLevelMentorGuidances = async function (
  apiData,
  courseSectionId,
  levelId
) {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/course_sections/${courseSectionId}/mentor_guidances/level/${levelId}`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )
    return await response.json()
  } catch (e) {}
}

export const setActivityCheckpointOverride = async (
  apiData,
  courseSectionId,
  levelId,
  activityId,
  checkpoint,
  applyToAllSections
) => {
  const response = checkHttpStatus(
    await fetch(
      `${getApiBaseUrl()}/api/organizations/${
        apiData.orgId
      }/mentor/course_sections/${courseSectionId}/levels/${levelId}/mentor_activity_checkpoint_overrides`,
      {
        method: 'POST',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify({
          activity_id: activityId,
          checkpoint_override: { checkpoint },
          apply_to_all_sections: applyToAllSections
        })
      }
    )
  )

  return await response.json()
}

export const fetchMentorActivityCheckpointOverrides = async (
  apiData,
  courseSectionId,
  questId
) => {
  const params = qs.stringify({
    q: {
      quest_id: questId
    }
  })

  const url = `${getApiBaseUrlWithOrg(apiData.orgId)}/course_sections/${
    courseSectionId
  }/mentor_activity_checkpoint_overrides${questId ? `?${params}` : ''}`

  const response = checkHttpStatus(
    await fetch(url, {
      method: 'GET',
      headers: getApiHeadersFromToken(apiData.token)
    })
  )
  return await response.json()
}

export const fetchMentorResourceCounts = async (apiData, courseSectionId) => {
  const url = `${getApiBaseUrlWithOrg(apiData.orgId)}/mentor/course_sections/${
    courseSectionId
  }/mentor_activity_resource_counts`

  const response = checkHttpStatus(
    await fetch(url, {
      method: 'GET',
      headers: getApiHeadersFromToken(apiData.token)
    })
  )
  return await response.json()
}
